import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NomObjectTypes } from 'src/app/core/constants';
import { getNestedProperty } from 'src/app/shared/utils/object-utils';

@Component({
  selector: 'app-ag-type-pill-cell-renderer',
  templateUrl: './ag-type-pill-cell-renderer.component.html',
  styleUrl: './ag-type-pill-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgTypePillCellRendererComponent implements ICellRendererAngularComp {
  typeId: number | null = null;
  typeTitle: string = '';

  agInit(params: ICellRendererParams): void {
    this.setParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setParams(params);
    return true;
  }

  private setParams(params: any): void {
    this.typeId = getNestedProperty(params.data, 'object_type.id', null);
    this.typeTitle = getNestedProperty(params.data, 'object_type.title', '');
  }

  /** Same type -> product color map as ObjectCardComponent.feedTypeClassMap. */
  get cssClass(): string {
    switch (this.typeId) {
      case NomObjectTypes.ONLINE_FEED:
        return 'pill--online';
      case NomObjectTypes.SOCIAL_FEED:
        return 'pill--social';
      case NomObjectTypes.COMBINED_FEED:
        return 'pill--combined';
      case NomObjectTypes.CLIPPING_FEED:
        return 'pill--clipping';
      case NomObjectTypes.BROADCAST_FEED:
        return 'pill--broadcast';
      default:
        return 'pill--default';
    }
  }
}
